export const MODULES_LOADED_SUCCESSFULLY = "MODULES_LOADED_SUCCESSFULLY";
export const MODULES_LOAD_FAIL = "MODULES_LOAD_FAIL";
export const PORTAL_SETTINGS_LOAD_SUCCESSFULLY =
  "PORTAL_SETTINGS_LOAD_SUCCESSFULLY";
export const PORTAL_SETTINGS_LOAD_FAIL = "PORTAL_SETTINGS_LOAD_FAIL";



// WEBPACK FOOTER //
// ./src/store/ServiceModules/actionTypes.js